// extracted by mini-css-extract-plugin
export var assigneeBadge = "_la-0";
export var assigneeDetails = "_la-1";
export var assigneeInfo = "_la-2";
export var dropdownContainer = "_la-4";
export var dropdownImage = "_la-5";
export var editAssigneeInfo = "_la-3";
export var editAssigneeModalContainer = "_la-6";
export var hidden = "_la-8";
export var input = "_la-7";